import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  Drawer,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { fAlertToast, hasNonEnterStatus } from "../../../Utility/Utilitys";
import moment from "moment";
import AutocompleteCheckboxFixSizeUid from "./AutocompleteCheckboxFixSizeUid";
import { CmpDatePickerField001V1 } from "../../../Component/Common/ToolBox/ToolBoxV1";

import { PAP_HEAD_Delete_Api, PAP_Head_SaveApi } from "../../../Server/ApiV2";
import SideNavToolbar from "../Components/SidenavToolbar";
import "../Components/promotion.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { vRdxUserInfo } from "../../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert";

const PromotionCreation = ({
  open,
  onClose,
  selectedPromo,
  setSelectedPromo,
  locations,
  loadSummary,
  userCd,
  bookletSizes,
  locationArr,
}) => {
  const [formData, setFormData] = useState({});

  const [locData, setLocData] = useState([]);
  const vRdxUserInfoObj = vRdxUserInfo();
  const promoTypes = ["Flyer", "Loyalty", "X & Y"];

  let initial = {
    PromoTitle: "",
    PromoLoc: "",
    TransLoc: "",
    Pages: "",
    BookletSize: "",
    PromoTyp: "",
  };
  const [errors, setErrors] = useState({ initial });

  useEffect(() => {
    if (selectedPromo) {
      setFormData(selectedPromo || {});
    }

    setTimeout(() => {
      document.getElementsByName("PromoTitle")[0]?.focus();
    }, 400);
  }, [selectedPromo]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const validateFields = () => {
    let tempError = {};

    if (!formData?.PromoTitle?.trim?.())
      tempError.PromoTitle = "Promo Title should not be empty";
    if (
      !Array.isArray(formData?.PromoLoc) ||
      formData.PromoLoc.filter((v) => String(v).trim()).length === 0
    ) {
      tempError.PromoLoc = "Promo Location should not be empty";
    }
    if (!formData?.TransLoc?.trim?.())
      tempError.TransLoc = "Location is required";

    const iPages = formData?.Pages ?? 0;
    if (iPages == 0) tempError.Pages = "Please enter a valid number of pages";

    if (!formData?.BookletSize?.trim?.())
      tempError.BookletSize = "Booklet Size should not be empty";

    if (!formData?.PromoTyp?.trim?.())
      tempError.PromoTyp = "Promo Type should not be empty";

    setErrors(tempError);
    return Object.keys(tempError).length === 0;
  };

  const fSave = async () => {
    let validation = validateFields();
    if (!validation) return;

    const obj = {
      TransId: formData.TransId,
      PromoTitle: formData.PromoTitle,
      TransLoc: formData.TransLoc,
      PromoLoc: formData?.PromoLoc.toString() || "",
      FromDt: moment(formData.FromDt).format("MM/DD/YYYY"),
      ToDt: moment(formData.ToDt).format("MM/DD/YYYY"),
      PromoTyp: formData.PromoTyp,
      Pages: Number(formData.Pages),
      BookletSize: formData.BookletSize,
      Curstk: formData.Curstk,
      ItmNameFlyer: formData?.ItmNameFlyer,
      UserCd: userCd ?? "",
    };

    const result = await PAP_Head_SaveApi(obj);

    if (result?.status === 200) {
      fAlertToast("SUCCESS", "Saved Successfully!");
      await loadSummary();
      setFormData((prev) => ({
        ...prev,
        TransId: result?.data?.recordset[0]?.TransId,
      }));
      setSelectedPromo((prev) => ({
        ...prev,
        TransId: result?.data?.recordset[0]?.TransId,
      }));
    }
  };

  const fDelete = async () => {
    try {
      const res = await PAP_HEAD_Delete_Api({
        TransId: formData?.TransId,
        UserCd: vRdxUserInfoObj?.UserID,
      });
      if (res?.status === 200) {
        fAlertToast("SUCCESS", "Deleted Successfully");
        await loadSummary();
        onClose();
      } else {
        fAlertToast("FAILED", res?.response?.data?.error || res?.message);
      }
    } catch (error) { }
  };

  const handleEnterFocus = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setTimeout(() => {
        document.getElementById(nextRef).focus();
      }, 400);
    }
  };

  useEffect(() => {
    setLocData(locationArr ?? []);
  }, [locationArr]);

  return (
    <Drawer
      anchor="right"
      open={open}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 450, md: "500px !important" },
        },
      }}
    >
      <Box mt={4}>
        <Box
          sx={{
            background: "linear-gradient(135deg, #1e88e5 0%, #673ab7 100%)",
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: { xs: 2, sm: 1.2 },
            mt: { xs: "10px", sm: "12px" },
            borderBottom: "1px solid #1565c0",
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <IconButton
              edge="end"
              onClick={() => {
                onClose();
                setFormData({});
                setErrors({});
                setSelectedPromo({});
              }}
              aria-label="close"
              sx={{
                fontSize: "20px !important",
                color: "#ffffff", // 👈 white icon color
                backgroundColor: "rgba(255,255,255,0.15)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.25)",
                },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography
              variant="h6"
              sx={{ fontWeight: 500, marginLeft: "22px", marginTop: "4px" }}
            >
              Promotion
            </Typography>
          </div>

          <IconButton
            onClick={() => {
              onClose();
              setFormData({});
              setErrors({});
              setSelectedPromo({});
            }}
            sx={{
              color: "#ffffff",
              backgroundColor: "rgba(255,255,255,0.15)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.25)",
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <SideNavToolbar
          userCd={userCd}
          transId={formData?.TransId || selectedPromo?.TransId || ""}
          selectedRow={selectedPromo}
          loadSummary={loadSummary}
        />
      </Box>
      <Box
        sx={{
          height: "85vh",
          overflowY: "auto",
        }}
      >
        <Grid
          container
          spacing={3}
          p={3}
          className="itemSearch"
        >
          <Grid item xs={6} md={6} sm={6}>
            <TextField
              fullWidth
              label="Trans ID"
              name="TransId"
              size="small"
              value={formData.TransId}
              onChange={(e) => handleChange("TransId", e.target.value)}
              disabled
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={6} md={6} sm={6}>
            <CmpDatePickerField001V1
              xLabelText="Trans Date"
              xName="TransDt"
              xDisable="disabled"
              xValue={formData.TransDt}
              xOnChange={(newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  TransDt: newValue,
                }));
              }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              label="PromoTitle"
              name="PromoTitle"
              onKeyDown={(e) => handleEnterFocus(e, "TransLoc")}
              size="small"
              autoComplete="off"
              value={formData.PromoTitle}
              onChange={(e) => handleChange("PromoTitle", e.target.value)}
              error={!!errors.PromoTitle}
              helperText={errors.PromoTitle}
            />
          </Grid>
          <Grid item xs={12} md={12} sm={12}>
            <Autocomplete
              freeSolo
              disableClearable
              id="TransLoc"
              options={locData}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.Name1
              }
              value={
                locData.find((loc) => loc.UId === formData?.TransLoc) || null
              }
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  setFormData((prev) => ({
                    ...prev,
                    TransLoc: newValue,
                  }));
                } else if (newValue) {
                  setFormData((prev) => ({
                    ...prev,
                    TransLoc: newValue.Uid,
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    TransLoc: "",
                  }));
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setTimeout(() => {
                    document.getElementsByName("PromoLoc")[0]?.focus();
                  }, 200);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Trans Loc"
                  name="TransLoc"
                  size="small"
                  error={!!errors.TransLoc}
                  helperText={errors.TransLoc}
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      type: "search",
                    },
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <AutocompleteCheckboxFixSizeUid
              options={locations ?? []}
              xValue={formData.PromoLoc}
              label={"Promo loc"}
              xtabIndex={"promo Loc"}
              setValue={setFormData}
              setError={setErrors}
              objName="PromoLoc"
              autoComplete="off"
              placeholder="Search Location"
              onChange={(event, newValue) => {
                console.log("Promo location changed:", newValue);
                setErrors((prev) => ({ ...prev, PromoLoc: "" }));
              }}
            />
            {errors.PromoLoc && (
              <Typography color="error" variant="caption">
                {errors.PromoLoc}
              </Typography>
            )}
          </Grid>

          <Grid item xs={6} md={6} sm={6}>
            <CmpDatePickerField001V1
              xName="FromDt"
              xLabelText="From Date"
              xValue={formData?.FromDt}
              xOnChange={(newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  FromDt: newValue?.$d ?? newValue,
                }));
              }}
            />
          </Grid>
          <Grid item xs={6} md={6} sm={6}>
            <CmpDatePickerField001V1
              xName="ToDt"
              xLabelText="To Date"
              xValue={formData?.ToDt}
              xOnChange={(newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  ToDt: newValue?.$d ?? newValue,
                }));
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} sm={12}>
            <FormControl fullWidth>
              <InputLabel>Promo Typ</InputLabel>
              <Select
                value={formData.PromoTyp || ""}
                label="Promo Typ"
                name="PromoTyp"
                autoComplete="off"
                size="small"
                onChange={(e) => handleChange("PromoTyp", e.target.value)}
              >
                {promoTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
              {errors.PromoTyp && (
                <Typography color="error" variant="caption">
                  {errors.PromoTyp}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6} md={6} sm={6}>
            <TextField
              fullWidth
              label="Pages"
              name="Pages"
              autoComplete="off"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={formData.Pages}
              onFocus={(e) => {
                if (e.target.value === "0") {
                  handleChange("Pages", "");
                }
              }}
              onChange={(e) => {
                const value = e.target.value;
                if (
                  value === "" ||
                  (/^\d+$/.test(value) && Number(value) >= 0)
                ) {
                  handleChange("Pages", value);
                }
              }}
              error={!!errors.Pages}
              helperText={errors.Pages}
            />
          </Grid>
          <Grid item xs={6} md={6} sm={6}>
            <FormControl fullWidth>
              <InputLabel>BookletSize</InputLabel>
              <Select
                label="bookletSize"
                variant="outlined"
                value={formData.BookletSize || ""}
                name="BookletSize"
                size="small"
                onChange={(e) => handleChange("BookletSize", e.target.value)}
              >
                {bookletSizes.map((size) => (
                  <MenuItem key={size.UID} value={size.UID}>
                    {size.Name1}
                  </MenuItem>
                ))}
              </Select>
              {errors.BookletSize && (
                <Typography color="error" variant="caption">
                  {errors.BookletSize}
                </Typography>
              )}
            </FormControl>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 4,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={fSave}
            sx={{ width: 120 }}
            disabled={hasNonEnterStatus(selectedPromo)}
          >
            Save
          </Button>
          <Tooltip title="Delete">
            <span>
              <Button
                variant="contained"
                disabled={
                  selectedPromo.TransId == 0 || hasNonEnterStatus(selectedPromo)
                }
                color="error"
                sx={{ width: 120 }}
                onClick={() =>
                  confirmAlert({
                    title: "Delete",
                    message: "Are you sure do you want delete ?",
                    buttons: [
                      {
                        className: "alertBtn",
                        label: "Yes",
                        onClick: fDelete,
                      },
                      {
                        className: "alertBtn",
                        label: "No",
                      },
                    ],
                  })
                }
              >
                Delete
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Box>
    </Drawer>
  );
};

export default PromotionCreation;
